import { useEffect, useState } from 'react';

const INITIAL_MESSAGE = 'Updating price...';
const STILL_WORKING_MESSAGE = 'Still working — usually about 15 seconds';
const STILL_WORKING_DELAY_MS = 10000;

const useUpdatingPriceMessage = (loading) => {
  const [stillWorking, setStillWorking] = useState(false);

  useEffect(() => {
    if (!loading) {
      setStillWorking(false);
      return undefined;
    }
    const timer = setTimeout(() => setStillWorking(true), STILL_WORKING_DELAY_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  return stillWorking ? STILL_WORKING_MESSAGE : INITIAL_MESSAGE;
};

export default useUpdatingPriceMessage;
